import React, { Component } from 'react';
import {Route, Link} from 'react-router-dom';

import './Gugi.scss';

class Gugi extends Component {
  render() {
    const {input, onChange} = this.props;

    return (
      <li>
        <Link to="/gugi/detail">
          <div className="dashed-wrap gugi">
            <h4 className="content-title">
              <span className="font-company">Google, TAE System & Typefaces Co. </span>
              <span className="font-title">Gugi</span>
            </h4>
            <p className="font-text">{input}</p>
          </div>
        </Link>
      </li>
    );
  }
}

export default Gugi;